import React from 'react';
import PropTypes from 'prop-types';

import { DropdownButton, MenuItem } from 'react-bootstrap';

import StagePip from 'bundles/apex/deals/stages/pip';
import { getOrderedStages } from 'bundles/apex/helpers/stages';

function StageSelect({ setStage, stages, stage }) {
  const orderedStages = getOrderedStages(stages);

  return (
    <DropdownButton
      bsSize="small"
      className="ml-1"
      id="stage-dropdown"
      title={
        <span className="stage-entry">
          <StagePip className="mr-2" stage={stage.key} />
          {stage.label}
        </span>
      }
    >
      {orderedStages.map(stage => (
        <MenuItem key={stage.key} name={stage.key} onClick={() => setStage(stage)}>
          <div className="stage-entry">
            <StagePip className="mr-2" stage={stage.key} />
            {stage.label}
          </div>
        </MenuItem>
      ))}
    </DropdownButton>
  );
}

StageSelect.propTypes = {
  setStage: PropTypes.func.isRequired,
  stage: PropTypes.shape({
    key: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
  stages: PropTypes.object.isRequired,
};

export default StageSelect;